export default "__VITE_ASSET__88811dbb__"